module.exports = __webpack_public_path__ + "static/media/bookmark_border-24px copy.85e193b1.svg";